module.exports = __webpack_public_path__ + "img/arh_13.60df6ac8.jpg";